import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=1c59f27c&scoped=true&"
import script from "./demandList.vue?vue&type=script&lang=js&"
export * from "./demandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59f27c",
  null
  
)

export default component.exports